module.exports = __webpack_public_path__ + "img/masterclass-sesi-1.734df6b3.png";